import dataFetcher from "modules/dataFetcher";
import { createSelector } from "reselect";
import api, { nonProjectApi } from "services/api";
import store from "services/store";

export function createMaasFormFactory(
  {
    formModuleName,
    formActions,
    getCloudAccountUid,
    getOverlordUid = () => null,
  } = {},
  { isOverlord = false, isNodes = false } = {}
) {
  const domainsFetcher = dataFetcher({
    selectors: ["maas", "domains", getCloudAccountUid],
    fetchData: async ([_1, _2, cloudAccountUid]) => {
      const domains = await api.get(
        `v1/cloudaccounts/maas/${cloudAccountUid}/properties/domains`
      );

      return domains;
    },
  });

  const resourcePoolsFetcher = dataFetcher({
    selectors: ["maas", "resourcePools", getCloudAccountUid],
    fetchData: async ([_1, _2, cloudAccountUid]) => {
      const resourcePools = await api.get(
        `v1/cloudaccounts/maas/${cloudAccountUid}/properties/resourcePools`
      );

      return resourcePools;
    },
  });

  const subnetsFetcher = dataFetcher({
    selectors: ["maas", "subnets", getCloudAccountUid],
    fetchData: async ([_1, _2, cloudAccountUid, region, domain, project]) => {
      const subnets = await api.get(
        `v1/cloudaccounts/maas/${cloudAccountUid}/properties/subnets`
      );

      return subnets;
    },
  });

  const azsFetcher = dataFetcher({
    selectors: ["maas", "azs", getCloudAccountUid],
    fetchData: async ([_1, _2, cloudAccountUid]) => {
      const azs = await api.get(
        `v1/cloudaccounts/maas/${cloudAccountUid}/properties/azs`
      );

      return azs;
    },
  });

  const tagsFetcher = dataFetcher({
    selectors: ["maas", "tags", getCloudAccountUid],
    fetchData: async ([_1, _2, cloudAccountUid]) => {
      const tags = await api.get(
        `v1/cloudaccounts/maas/${cloudAccountUid}/properties/tags`
      );

      return tags;
    },
  });

  const ipamsFetcher = dataFetcher({
    selectors: ["maas", "ipams", getOverlordUid],
    fetchData: async ([_1, _2, overlordUid]) => {
      const ipams = nonProjectApi.get(`v1/overlords/maas/${overlordUid}/pools`);

      return ipams;
    },
  });

  const getIpamsDetails = createSelector(
    ipamsFetcher.selector,
    ({ result }) => result?.items || []
  );

  const fetchProperties = () => {
    return Promise.allSettled([
      store.dispatch(azsFetcher.fetch()),
      store.dispatch(domainsFetcher.fetch()),
      store.dispatch(resourcePoolsFetcher.fetch()),
      store.dispatch(tagsFetcher.fetch()),
    ]);
  };

  return {
    actions: {
      onAccountFieldChange(name, value) {
        const isAccountValidated =
          store.getState().overlord.configure.isAccountValidated;

        store.dispatch(
          formActions.onChange({
            module: formModuleName,
            name,
            value,
          })
        );

        if (isAccountValidated) {
          store.dispatch(
            formActions.onChange({
              module: formModuleName,
              name: "apiKey",
              value: "",
            })
          );
        }
      },
    },
    effects: {
      fetchProperties,
    },
    fetchers: {
      azsFetcher,
      domainsFetcher,
      resourcePoolsFetcher,
      subnetsFetcher,
      tagsFetcher,
      ipamsFetcher,
    },
    selectors: {
      getIpamsDetails,
    },
  };
}
